export enum GaapType {
  Asset = 'ASSET',
  Liability = 'LIABILITY',
  Income = 'INCOME',
  Expense = 'EXPENSE',
  Equity = 'EQUITY',
  Revenue = 'REVENUE'
}